module.exports = __webpack_public_path__ + "static/media/kellie_judges_headshot.bdb61842.jpeg";